module.exports = __webpack_public_path__ + "asset/img/erweimaZ.96b3031.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/erweimaZ.png
// module id = 5hSr
// module chunks = 1